import script from "./TrackerSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./TrackerSplit.vue?vue&type=script&setup=true&lang=js"

import "./TrackerSplit.vue?vue&type=style&index=0&id=6e8a059b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8a059b"]])

export default __exports__